var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"account-avatar",attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"fas",class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }